/* ==============================================================
   OCALA E-BIKE COMPANY — Theme JS v2
   - Cart drawer (Shopify Cart AJAX API)
   - Product page (variants, qty, add-to-cart with addon)
   - Mobile menu, accordions, filter pills, lite YouTube embed
   ============================================================== */

(function () {
  'use strict';

  // ---------- Helpers ----------
  const money = (cents) => {
    if (cents == null) return '';
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const escapeHtml = (str) => String(str || '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[c]);

  const fetchJSON = (url, opts = {}) =>
    fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    }, opts)).then(r => {
      if (r.ok) return r.json();
      return r.json().then(err => { throw err; }).catch(() => { throw { description: 'Request failed' }; });
    });

  // Resize Shopify CDN image URLs without breaking on query strings or .webp
  const sizeImage = (url, w) => {
    if (!url) return '';
    return url.replace(/(_(?:pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*|\d*x\d+))?(\.(?:jpe?g|png|webp|gif|avif))(\?.*)?$/i, `_${w}x$2$3`);
  };

  // ---------- Inline SVG icons (must match snippets/icon.liquid) ----------
  // Used for HTML rendered client-side where Liquid can't reach (cart drawer)
  const ICON = {
    wrench: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="oec-icon" aria-hidden="true"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>',
    wrenchSm: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="oec-icon" aria-hidden="true"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>',
    check: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" class="oec-icon" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>'
  };


  // ---------- Cart drawer ----------
  const drawer = document.getElementById('cart-drawer');
  const cartBody = drawer ? drawer.querySelector('[data-cart-body]') : null;
  const updateCartCounts = (n) => document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = n);

  const openCart = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    renderCart();
    // Focus the close button for accessibility
    setTimeout(() => {
      const close = drawer.querySelector('.cart-drawer__close');
      if (close) close.focus();
    }, 320);
  };

  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-close-cart]')) { closeCart(); }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCart();
  });

  // ---------- Mobile full-screen menu ----------
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const openMobileMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.hidden = false;
    // Force a reflow before adding is-open so transitions fire
    void mobileMenu.offsetWidth;
    mobileMenu.classList.add('is-open');
    document.body.classList.add('oec-menu-open');
    document.querySelectorAll('[data-open-mobile-menu]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    // Focus close for accessibility
    setTimeout(() => {
      const close = mobileMenu.querySelector('[data-close-mobile-menu]');
      if (close) close.focus();
    }, 280);
  };
  const closeMobileMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    document.body.classList.remove('oec-menu-open');
    document.querySelectorAll('[data-open-mobile-menu]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    // Hide after transition completes
    setTimeout(() => { if (!mobileMenu.classList.contains('is-open')) mobileMenu.hidden = true; }, 320);
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-mobile-menu]')) { e.preventDefault(); openMobileMenu(); return; }
    if (e.target.closest('[data-close-mobile-menu]')) { e.preventDefault(); closeMobileMenu(); return; }
    // Click on backdrop (the overlay element itself, not its panel) closes it
    if (e.target === mobileMenu) { closeMobileMenu(); return; }
    // Tapping any link inside the menu closes it (so back-button feels natural after navigation)
    const navLink = e.target.closest('.oec-mobile-menu__link, .oec-mobile-menu__promo, .oec-mobile-menu__secondary, .oec-mobile-menu__foot-phone');
    if (navLink && mobileMenu && mobileMenu.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) closeMobileMenu();
  });

  // ---------- Pro Build resolution (with handle fallback) ----------
  // Returns a promise resolving to {variantId, productId, price, title} or null.
  let _pbResolvePromise = null;
  function resolveProBuild() {
    if (_pbResolvePromise) return _pbResolvePromise;
    const cfg = (window.OEC && window.OEC.probuild) || {};
    if (cfg.variantId && cfg.productId) {
      _pbResolvePromise = Promise.resolve({
        variantId: cfg.variantId,
        productId: cfg.productId,
        price: cfg.price || 0,
        title: cfg.title || 'Ride Ready Delivery'
      });
      return _pbResolvePromise;
    }
    const handle = cfg.fallbackHandle || 'ride-ready-delivery';
    _pbResolvePromise = fetchJSON('/products/' + encodeURIComponent(handle) + '.js')
      .then(p => {
        if (!p || !p.variants || !p.variants.length) return null;
        const v = p.variants.find(x => x.available) || p.variants[0];
        return {
          variantId: v.id,
          productId: p.id,
          price: v.price,
          title: p.title || 'Ride Ready Delivery'
        };
      })
      .catch(() => null);
    return _pbResolvePromise;
  }

  // ---------- Pro Build accessory reveal ----------
  // Fetches featured probuild-eligible bundles and renders them as add-to-cart options
  // at the top of the cart drawer after a customer adds Pro Build.
  function renderProBuildReveal(container, inCartHandles) {
    // The two featured bundle handles (matches the CSV imported tags)
    const featuredHandles = ['urban-safety-set-bundle', 'foldylock-compact-security-visibility-bundle'];
    const toFetch = featuredHandles.filter(h => !inCartHandles.has(h));
    if (toFetch.length === 0) return; // both already in cart

    Promise.all(toFetch.map(h =>
      fetch('/products/' + h + '.js')
        .then(r => r.ok ? r.json() : null)
        .catch(() => null)
    )).then(products => {
      const valid = products.filter(p => p && p.variants && p.variants.length);
      if (valid.length === 0) return;

      const itemsHtml = valid.map(p => {
        const v = p.variants.find(x => x.available) || p.variants[0];
        const img = p.featured_image ? sizeImage(p.featured_image, 120) : '';
        const compareHtml = (v.compare_at_price && v.compare_at_price > v.price)
          ? `<span class="cart-pb-reveal__compare">${money(v.compare_at_price)}</span>`
          : '';
        return `
          <div class="cart-pb-reveal__item">
            <div class="cart-pb-reveal__media">${img ? `<img src="${escapeHtml(img)}" alt="" loading="lazy" width="52" height="52">` : ''}</div>
            <div class="cart-pb-reveal__info">
              <div class="cart-pb-reveal__name">${escapeHtml(p.title)}</div>
              <div class="cart-pb-reveal__price-row">
                <span class="cart-pb-reveal__price">${money(v.price)}</span>
                ${compareHtml}
              </div>
            </div>
            <button type="button" class="cart-pb-reveal__add" data-add-pb-bundle data-variant-id="${v.id}" data-handle="${escapeHtml(p.handle)}">+ Add</button>
          </div>`;
      }).join('');

      const revealHtml = `
        <div class="cart-pb-reveal" data-pb-reveal>
          <div class="cart-pb-reveal__head">
            <span class="cart-pb-reveal__star" aria-hidden="true">★</span>
            <strong class="cart-pb-reveal__title">Pro Build includes free install for up to 3 accessories</strong>
          </div>
          <p class="cart-pb-reveal__sub">These popular bundles pair perfectly with your new Magnum and install at no extra charge.</p>
          <div class="cart-pb-reveal__items">${itemsHtml}</div>
          <button type="button" class="cart-pb-reveal__skip" data-pb-skip>No thanks, continue to checkout</button>
        </div>`;
      container.insertAdjacentHTML('afterbegin', revealHtml);
      container.scrollTop = 0;
    });
  }

  const renderCart = () => {
    if (!cartBody) return;
    Promise.all([fetchJSON('/cart.js'), resolveProBuild()])
      .then(([cart, pb]) => {
        updateCartCounts(cart.item_count);

        // Remove old footer
        const oldFoot = drawer.querySelector('.cart-drawer__foot');
        if (oldFoot) oldFoot.remove();

        if (cart.item_count === 0) {
          cartBody.innerHTML = `
            <div class="cart-drawer__empty">
              <p>Your cart is empty.</p>
              <a href="/collections/magnum-e-bikes" class="oec-btn oec-btn--primary" style="margin-top:16px">Browse the lineup</a>
            </div>`;
          return;
        }

        // ----- Bike ↔ Pro Build pairing logic -----
        const pbId = pb ? pb.productId : null;
        const pbVariantId = pb ? pb.variantId : null;
        const pbPrice = pb ? pb.price : 0;

        // Tally builds paired to each bike variant ID, and untagged builds
        const pairedBuilds = {}; // variantId -> qty
        let untaggedBuilds = 0;
        cart.items.forEach(item => {
          if (pbId && item.product_id === pbId) {
            const pair = item.properties && item.properties._pairs_with;
            if (pair) {
              pairedBuilds[pair] = (pairedBuilds[pair] || 0) + item.quantity;
            } else {
              untaggedBuilds += item.quantity;
            }
          }
        });

        // For each bike, distribute untagged builds to cover gaps (oldest-first)
        const bikeGaps = []; // [{ key, variantId, gap }]
        cart.items.forEach(item => {
          if (pbId && item.product_id === pbId) return;
          const paired = pairedBuilds[item.variant_id] || 0;
          let gap = item.quantity - paired;
          if (gap > 0 && untaggedBuilds > 0) {
            const use = Math.min(untaggedBuilds, gap);
            untaggedBuilds -= use;
            gap -= use;
            pairedBuilds[item.variant_id] = paired + use;
          }
          bikeGaps.push({ key: item.key, variantId: item.variant_id, gap: Math.max(0, gap), bikeQty: item.quantity, coveredQty: item.quantity - Math.max(0, gap) });
        });

        // Lookup helper
        const gapByKey = {};
        bikeGaps.forEach(g => { gapByKey[g.key] = g; });

        // ----- Render lines -----
        const lines = cart.items.map(item => {
          const imgSrc = item.image ? sizeImage(item.image, 128) : '';
          const titleHtml = escapeHtml(item.product_title);
          const variantHtml = (item.variant_title && item.variant_title !== 'Default Title') ? `<div class="cart-line__meta">${escapeHtml(item.variant_title)}</div>` : '';
          const sellingPlan = item.selling_plan_allocation ? `<div class="cart-line__meta">${escapeHtml(item.selling_plan_allocation.selling_plan.name)}</div>` : '';
          const url = escapeHtml(item.url);
          const isPB = pbId && item.product_id === pbId;

          let afterLineHtml = '';
          if (!isPB) {
            const gap = gapByKey[item.key];
            if (gap && gap.gap > 0 && pbVariantId) {
              // Per-bike red strip — compact, contextual upsell
              const lineTotal = pbPrice * gap.gap;
              const qtyLabel = gap.gap > 1 ? ` × ${gap.gap}` : '';
              afterLineHtml = `
                <form class="cart-bike-upsell" data-bike-upsell action="/cart/add" method="post">
                  <input type="hidden" name="id" value="${pbVariantId}">
                  <input type="hidden" name="quantity" value="${gap.gap}">
                  <input type="hidden" name="properties[_pairs_with]" value="${item.variant_id}">
                  <input type="hidden" name="properties[For]" value="${escapeHtml(item.product_title)}${gap.gap > 1 ? ' × ' + gap.gap : ''}">
                  <div class="cart-bike-upsell__head">
                    <span class="cart-bike-upsell__icon" aria-hidden="true">${ICON.wrench}</span>
                    <div class="cart-bike-upsell__text">
                      <strong>Skip the box for this bike.</strong>
                      <span>Hand-delivered ready to ride · ${money(pbPrice)}${qtyLabel}</span>
                    </div>
                  </div>
                  <button type="submit" class="cart-bike-upsell__btn" data-add-bike-probuild>
                    + Add Pro Build${gap.gap > 1 ? ` (×${gap.gap})` : ''} · ${money(lineTotal)}
                  </button>
                </form>`;
            } else if (gap && gap.coveredQty > 0) {
              // Green confirmation pill — bike has Pro Build paired
              afterLineHtml = `
                <div class="cart-bike-confirm">
                  <span class="cart-bike-confirm__icon" aria-hidden="true">${ICON.check}</span>
                  <span>Pro Build added · ${gap.coveredQty} bike${gap.coveredQty > 1 ? 's' : ''} will arrive ride-ready</span>
                </div>`;
            }
          }

          const linkedBadge = isPB
            ? `<div class="cart-line__linked-badge">${ICON.wrenchSm} Pro Build · ${item.quantity} bike${item.quantity > 1 ? 's' : ''}</div>`
            : '';

          return `
            <div class="cart-line${isPB ? ' cart-line--addon' : ''}" data-line-key="${escapeHtml(item.key)}">
              <div class="cart-line__media">${imgSrc ? `<img src="${escapeHtml(imgSrc)}" alt="" loading="lazy" width="64" height="64">` : ''}</div>
              <div>
                <a href="${url}" class="cart-line__title">${titleHtml}</a>
                ${variantHtml}${sellingPlan}${linkedBadge}
                <div class="cart-line__qty" role="group" aria-label="Quantity for ${titleHtml}">
                  <button type="button" data-qty-down aria-label="Decrease quantity">−</button>
                  <input type="number" value="${item.quantity}" min="0" data-qty-input aria-label="Quantity">
                  <button type="button" data-qty-up aria-label="Increase quantity">+</button>
                </div>
                <button type="button" class="cart-line__remove" data-line-remove>Remove</button>
              </div>
              <div class="cart-line__price">${money(item.final_line_price)}</div>
            </div>
            ${afterLineHtml}`;
        }).join('');

        cartBody.innerHTML = lines;

        // Pro Build accessory reveal: triggers in two scenarios:
        // (1) Customer just clicked Add Pro Build (window flag set)
        // (2) Cart has Pro Build line(s) but featured bundles aren't all in cart yet
        const inCartHandles = new Set(cart.items.map(i => i.handle));
        const hasProBuild = cart.items.some(i => pbId && i.product_id === pbId);
        const justAdded = window._oecJustAddedProBuild;
        if (justAdded) window._oecJustAddedProBuild = false; // consume flag
        if (hasProBuild && (justAdded || !window._oecRevealShown)) {
          window._oecRevealShown = true;
          renderProBuildReveal(cartBody, inCartHandles);
        }

        const foot = document.createElement('div');
        foot.className = 'cart-drawer__foot';
        foot.innerHTML = `
          <div class="cart-drawer__totals">
            <span>Subtotal</span>
            <strong>${money(cart.total_price)}</strong>
          </div>
          <p class="cart-drawer__shipping-note">Shipping &amp; taxes calculated at checkout.</p>
          <a href="/checkout" class="oec-btn oec-btn--primary oec-btn--block oec-btn--lg">Checkout</a>
          <a href="/cart" style="display:block;text-align:center;margin-top:10px;font-size:0.88rem;color:var(--oec-ink-mute)">View full cart</a>`;
        drawer.querySelector('.cart-drawer__panel').appendChild(foot);
      })
      .catch(() => {
        cartBody.innerHTML = '<p class="cart-drawer__empty">Couldn\'t load cart. Please refresh.</p>';
      });
  };

  // Cart line interactions (delegated)
  let cartActionInProgress = false;
  document.addEventListener('click', (e) => {
    const line = e.target.closest('[data-line-key]');
    if (!line) return;
    const btn = e.target.closest('[data-qty-up], [data-qty-down], [data-line-remove]');
    if (!btn) return;
    if (cartActionInProgress) return;

    const key = line.getAttribute('data-line-key');
    const input = line.querySelector('[data-qty-input]');
    let qty = parseInt(input.value, 10) || 0;

    if (btn.matches('[data-qty-up]')) qty++;
    else if (btn.matches('[data-qty-down]')) qty = Math.max(0, qty - 1);
    else if (btn.matches('[data-line-remove]')) qty = 0;

    cartActionInProgress = true;
    line.style.opacity = '0.5';
    fetchJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) })
      .then(() => { cartActionInProgress = false; renderCart(); })
      .catch(() => { cartActionInProgress = false; line.style.opacity = '1'; });
  });

  // Direct quantity input (debounced)
  let qtyTimer;
  document.addEventListener('change', (e) => {
    const input = e.target.closest('.cart-line [data-qty-input]');
    if (!input) return;
    const line = input.closest('[data-line-key]');
    if (!line) return;
    const key = line.getAttribute('data-line-key');
    const qty = Math.max(0, parseInt(input.value, 10) || 0);
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(() => {
      cartActionInProgress = true;
      fetchJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) })
        .then(() => { cartActionInProgress = false; renderCart(); })
        .catch(() => { cartActionInProgress = false; });
    }, 350);
  });

  // Initial cart count
  fetchJSON('/cart.js').then(c => updateCartCounts(c.item_count)).catch(() => {});

  // Cart upsell: Add Pro Build directly from cart drawer
  // Handles BOTH the per-bike inline form [data-bike-upsell] AND legacy banner button
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-bike-upsell]');
    if (!form) return;
    e.preventDefault();
    if (cartActionInProgress) return;

    const btn = form.querySelector('[data-add-bike-probuild]');
    if (btn) {
      btn.disabled = true;
      btn._origText = btn.textContent;
      btn.textContent = 'Adding…';
    }
    cartActionInProgress = true;

    const formData = new FormData(form);
    fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        items: [{
          id: parseInt(formData.get('id'), 10),
          quantity: parseInt(formData.get('quantity'), 10) || 1,
          properties: {
            '_pairs_with': formData.get('properties[_pairs_with]') || '',
            'For': formData.get('properties[For]') || ''
          }
        }]
      })
    })
      .then(() => {
        cartActionInProgress = false;
        // Flag: just added Pro Build — trigger the featured-bundle reveal on next render
        window._oecJustAddedProBuild = true;
        renderCart();
      })
      .catch(() => {
        cartActionInProgress = false;
        if (btn) { btn.disabled = false; btn.textContent = btn._origText || '+ Add Pro Build'; }
      });
  });

  // Pro Build reveal: add featured bundle to cart
  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('[data-add-pb-bundle]');
    if (!addBtn) return;
    if (cartActionInProgress) return;
    const variantId = parseInt(addBtn.dataset.variantId, 10);
    if (!variantId) return;
    cartActionInProgress = true;
    addBtn.disabled = true;
    addBtn._orig = addBtn.textContent;
    addBtn.textContent = 'Adding…';
    fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_probuild_install': 'Free with Pro Build' } }] })
    })
      .then(() => { cartActionInProgress = false; renderCart(); })
      .catch(() => { cartActionInProgress = false; addBtn.disabled = false; addBtn.textContent = addBtn._orig || '+ Add'; });
  });

  // Pro Build reveal: skip — dismiss the reveal panel
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-pb-skip]')) return;
    const panel = document.querySelector('[data-pb-reveal]');
    if (panel) {
      panel.style.opacity = '0';
      panel.style.maxHeight = '0';
      panel.style.padding = '0';
      panel.style.margin = '0';
      setTimeout(() => panel.remove(), 300);
    }
  });

  // Legacy banner button handler (kept for backwards-compat with cart page Liquid form)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add-probuild]');
    if (!btn) return;
    if (cartActionInProgress) return;
    const variantId = parseInt(btn.dataset.variantId, 10);
    const qty = parseInt(btn.dataset.qty, 10) || 1;
    if (!variantId) return;
    cartActionInProgress = true;
    btn.disabled = true;
    const main = btn.querySelector('.cart-upsell__btn-main');
    if (main) main.textContent = 'Adding…';
    fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(() => {
        cartActionInProgress = false;
        window._oecJustAddedProBuild = true;
        renderCart();
      })
      .catch(() => { cartActionInProgress = false; btn.disabled = false; });
  });

  // ---------- Add-to-cart (works for product page main form + addon) ----------
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('[data-add-btn]');
    const originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    const formData = new FormData(form);
    const variantId = parseInt(formData.get('id'), 10);
    if (!variantId) {
      if (btn) { btn.disabled = false; btn.textContent = originalText; }
      return;
    }

    const bikeQty = Math.max(1, parseInt(formData.get('quantity') || '1', 10));

    const items = [{
      id: variantId,
      quantity: bikeQty
    }];

    // Pro Build addon — qty matches bike qty (per-bike service)
    const addonBox = document.querySelector('[data-addon]');
    if (addonBox && addonBox.classList.contains('is-checked')) {
      const addonId = parseInt(addonBox.dataset.variantId, 10);
      if (addonId) items.push({
        id: addonId,
        quantity: bikeQty,
        properties: {
          '_pairs_with': String(variantId),
          'For': bikeQty + ' bike' + (bikeQty > 1 ? 's' : '')
        }
      });
    }

    fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) })
      .then(() => {
        if (btn) {
          btn.innerHTML = 'Added ' + ICON.check;
          setTimeout(() => { btn.disabled = false; btn.textContent = originalText; }, 1400);
        }
        openCart();
      })
      .catch(err => {
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
        const msg = (err && err.description) || 'Could not add to cart.';
        alert(msg);
      });
  });

  // ---------- Pro Build addon toggle ----------
  document.addEventListener('click', (e) => {
    const head = e.target.closest('[data-addon-toggle]');
    if (head) {
      const box = head.closest('[data-addon]');
      if (box) {
        const checked = box.classList.toggle('is-checked');
        head.setAttribute('aria-checked', checked ? 'true' : 'false');
      }
      return;
    }
    const expand = e.target.closest('[data-addon-expand]');
    if (expand) {
      e.preventDefault();
      e.stopPropagation();
      const box = expand.closest('[data-addon]');
      if (box) {
        const expanded = box.classList.toggle('is-expanded');
        expand.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }
  });

  // Keyboard support for addon toggle
  document.addEventListener('keydown', (e) => {
    if ((e.key === ' ' || e.key === 'Enter') && e.target.matches('[data-addon-toggle]')) {
      e.preventDefault();
      e.target.click();
    }
  });

  // ---------- Variant picker ----------
  document.addEventListener('click', (e) => {
    const opt = e.target.closest('[data-variant-option]');
    if (!opt) return;
    if (opt.disabled) return;
    const group = opt.closest('[data-variant-group]');
    if (!group) return;
    group.querySelectorAll('[data-variant-option]').forEach(o => o.classList.remove('is-active'));
    opt.classList.add('is-active');
    // Update inline current-value label
    const root = opt.closest('[data-product-root]');
    if (root) {
      const groups = Array.from(root.querySelectorAll('[data-variant-group]'));
      const idx = groups.indexOf(group);
      const currentEl = root.querySelector(`[data-variant-current="${idx}"]`);
      if (currentEl) currentEl.textContent = opt.dataset.value;
    }
    updateVariantSelection(root);
  });

  function updateVariantSelection(root) {
    if (!root) return;
    const variantsScript = root.querySelector('[data-variants-json]');
    if (!variantsScript) return;
    let variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    const selected = Array.from(root.querySelectorAll('[data-variant-group]')).map(g => {
      const a = g.querySelector('.is-active');
      return a ? a.dataset.value : null;
    });
    const variant = variants.find(v => v.options.every((opt, i) => opt === selected[i]));
    if (!variant) return;

    const idInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-variant-price]');
    const compareEl = root.querySelector('[data-variant-compare]');
    const saveEl = root.querySelector('[data-variant-save]');
    const btn = root.querySelector('[data-add-btn]');

    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = money(variant.compare_at_price);
        compareEl.style.display = '';
        if (saveEl) {
          saveEl.textContent = 'Save ' + money(variant.compare_at_price - variant.price);
          saveEl.style.display = '';
        }
      } else {
        compareEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }
    }

    if (btn) {
      if (variant.available) {
        btn.disabled = false;
        btn.textContent = btn.dataset.availableText || 'Add to cart';
      } else {
        btn.disabled = true;
        btn.textContent = 'Sold out';
      }
    }

    if (window.history && history.replaceState) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }

    if (variant.featured_image && variant.featured_image.src) {
      // v6: scroll gallery to the matching image instead of replacing src
      if (typeof root._pdpGoToImage === 'function') {
        root._pdpGoToImage(variant.featured_image.src);
      } else {
        const main = root.querySelector('[data-main-img] img');
        if (main) main.src = sizeImage(variant.featured_image.src, 1200);
      }
    }
  }

  // ---------- Product gallery (v6 — swipe, dots, thumbs, sticky bar) ----------
  function pdpInit() {
    const root = document.querySelector('[data-product-root]');
    if (!root) return;
    const track = root.querySelector('[data-gallery-track]');
    if (!track) return;
    const slides = Array.from(track.querySelectorAll('.oec-pdp__main-slide'));
    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));

    function setActive(idx) {
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    }

    function goTo(idx) {
      const target = slides[idx];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      setActive(idx);
    }

    // Track scroll → update active dot/thumb
    let scrollDebounce;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(() => {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        setActive(idx);
      }, 80);
    });

    // Dot clicks
    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(parseInt(dot.dataset.slide, 10)));
    });

    // Thumb clicks
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => goTo(parseInt(thumb.dataset.slide, 10)));
    });

    // Prev/next nav
    const prev = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', () => {
      const idx = Math.round(track.scrollLeft / track.clientWidth);
      goTo(Math.max(0, idx - 1));
    });
    if (next) next.addEventListener('click', () => {
      const idx = Math.round(track.scrollLeft / track.clientWidth);
      goTo(Math.min(slides.length - 1, idx + 1));
    });

    // Expose helper for variant changes
    root._pdpGoToImage = (src) => {
      const matchIdx = slides.findIndex(s => {
        const img = s.querySelector('img');
        return img && img.src.indexOf(src.split('?')[0].split('/').pop().split('.')[0]) > -1;
      });
      if (matchIdx > -1) goTo(matchIdx);
    };
  }

  // YouTube card embed (PDP video walkthrough)
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.oec-pdp__video[data-yt-id]');
    if (!trigger) return;
    e.preventDefault();
    const id = trigger.dataset.ytId;
    if (!id) return;
    trigger.innerHTML = `<iframe src="https://www.youtube.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0" title="${escapeHtml(trigger.getAttribute('aria-label') || 'Video')}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>`;
  });

  // Mobile sticky buy bar
  function stickyBarInit() {
    const bar = document.querySelector('[data-sticky-bar]');
    const buyBtn = document.querySelector('[data-add-btn]');
    if (!bar || !buyBtn) return;
    const stickyBtn = bar.querySelector('[data-sticky-btn]');
    const stickyPrice = bar.querySelector('[data-sticky-price]');
    const priceEl = document.querySelector('[data-variant-price]');

    // Sync sticky bar state from main button
    function sync() {
      if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent;
      stickyBtn.disabled = buyBtn.disabled;
      stickyBtn.textContent = buyBtn.textContent;
    }

    // Sticky bar shows when main buy button is offscreen
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
          // Buy button is visible OR scrolled past the top — hide sticky
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top > 0);
        } else {
          // Below viewport — show sticky
          bar.classList.add('is-visible');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -120px 0px' });
    obs.observe(buyBtn);

    // Clicking sticky button submits the main form
    stickyBtn.addEventListener('click', () => {
      const form = buyBtn.closest('form');
      if (form && typeof form.requestSubmit === 'function') {
        form.requestSubmit(buyBtn);
      } else if (form) {
        buyBtn.click();
      }
    });

    // Keep sticky in sync after variant changes
    sync();
    new MutationObserver(sync).observe(buyBtn, { childList: true, attributes: true, characterData: true, subtree: true });
    if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { pdpInit(); stickyBarInit(); });
  } else {
    pdpInit();
    stickyBarInit();
  }

  // ---------- Product page quantity steppers ----------
  function syncAddonPrice(qty) {
    const addonBox = document.querySelector('[data-addon]');
    if (!addonBox) return;
    const unitPrice = parseInt(addonBox.dataset.addonPrice, 10);
    if (!unitPrice) return;
    const display = addonBox.querySelector('[data-addon-price-display]');
    const ctx = addonBox.querySelector('[data-addon-context]');
    const total = unitPrice * qty;
    if (display) {
      if (qty > 1) {
        display.innerHTML = `+ ${money(total)} <span style="font-size:0.78rem;font-weight:500;opacity:0.75;">(${money(unitPrice)} × ${qty})</span>`;
      } else {
        display.textContent = '+ ' + money(unitPrice);
      }
    }
    if (ctx) {
      ctx.textContent = qty > 1
        ? `Builds ${qty} bikes — one Pro Build per bike`
        : 'per bike · scales with quantity';
    }
  }

  document.addEventListener('click', (e) => {
    const dec = e.target.closest('[data-qty-dec]');
    const inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;
    const wrap = (dec || inc).closest('[data-qty-wrap]');
    if (!wrap) return;
    const input = wrap.querySelector('input');
    let v = parseInt(input.value, 10) || 1;
    if (dec) v = Math.max(1, v - 1);
    if (inc) v = v + 1;
    input.value = v;
    syncAddonPrice(v);
  });

  // Direct typing into product qty input
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-qty-wrap] input');
    if (!input) return;
    const v = Math.max(1, parseInt(input.value, 10) || 1);
    syncAddonPrice(v);
  });

  // Initial sync on page load
  document.addEventListener('DOMContentLoaded', () => {
    const input = document.querySelector('[data-qty-wrap] input');
    if (input) syncAddonPrice(parseInt(input.value, 10) || 1);
  });

  // ---------- Accordions ----------
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.oec-acc__btn');
    if (!btn) return;
    const item = btn.parentElement;
    const wasOpen = item.classList.contains('is-open');
    item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
  });

  // ---------- Collection filter pills (client-side) ----------
  document.addEventListener('click', (e) => {
    const pill = e.target.closest('[data-filter]');
    if (!pill) return;
    const grid = document.querySelector('[data-filter-grid]');
    if (!grid) return;
    const filter = pill.dataset.filter;
    document.querySelectorAll('[data-filter]').forEach(p => p.classList.remove('is-active'));
    pill.classList.add('is-active');
    grid.querySelectorAll('[data-tags]').forEach(card => {
      const tags = (card.dataset.tags || '').split(',');
      card.style.display = (filter === 'all' || tags.includes(filter)) ? '' : 'none';
    });
  });

  // ---------- Lite YouTube embed (only loads iframe on click) ----------
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-yt-id]');
    if (!trigger) return;
    e.preventDefault();
    const id = trigger.dataset.ytId;
    if (!id) return;
    const wrap = trigger.closest('.oec-video');
    if (!wrap) return;
    wrap.innerHTML = `<iframe src="https://www.youtube.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0" title="${escapeHtml(trigger.getAttribute('aria-label') || 'Video')}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>`;
  });
})();
